import { closeModal, openContextModal } from "@mantine/modals";
import { ReferralModalContent } from "./referral-modal-content";

let modalId: string | null = null;

export function openReferralModal() {
	modalId = openContextModal({
		modal: "buttonsModal",
		centered: true,
		withCloseButton: false,
		zIndex: 5000,
		size: "440px",
		padding: 0,
		classNames: {
			content:
				"relative shadow-2xl border border-border-subtle bg-surface-default mx-4 sm:mx-0 rounded-2xl max-h-[90dvh] flex flex-col",
			body: "overflow-y-auto flex-1",
		},
		onClose: () => {
			modalId = null;
		},
		innerProps: {
			children: <ReferralModalContent onClose={closeReferralModal} />,
		},
	});
}

export function closeReferralModal() {
	if (modalId) {
		closeModal(modalId);
	}
}
